<template>
  <div class="container-purchase">
    <div v-if="$route.query.type === 'detail'" class="model"></div>
    <div style="display: flex">
      <div class="left">
        <div class="search">
          <div>物料类别:</div>
          <el-input
            v-model="mdmCategoryQuery.mdmCategoryName"
            placeholder="请输入最小分类名称"
            style="width: 188px"
          ></el-input>
          <el-button
            type="primary"
            style="width: 80px; margin-left: 5px"
            @click="mdmHandleSearch"
            >查询</el-button
          >

          <div>查询物料类别:</div>
          <div class="scrollbar">
            <el-scrollbar
              v-show="searchTreeShow"
              ref="scrollbarCategory"
              :native="false"
              style="height: 100%"
            >
              <el-tree
                key="2"
                ref="tree"
                class="tree"
                :props="searchTreeProps"
                :data="searchTreeData"
                node-key="categoryId"
                :default-expand-all="true"
                @node-click="handleNodeClick"
              >
                <template #default="{ node }">
                  <el-tooltip
                    v-if="node.label.length > 15"
                    class="item"
                    effect="dark"
                    :content="node.label"
                    placement="right"
                  >
                    <div style="width: 205px" class="ellipsis">
                      {{ node.label }}
                    </div>
                  </el-tooltip>
                  <span v-else> {{ node.label }}</span>
                </template>
              </el-tree>
            </el-scrollbar>
            <el-scrollbar
              v-show="!searchTreeShow"
              ref="scrollbarCategory"
              :native="false"
              style="height: 100%"
            >
              <el-tree
                key="2"
                ref="tree"
                class="tree"
                :props="defaultProps"
                :data="treeData"
                node-key="categoryId"
                disabled
                lazy
                :load="loadNode"
                @node-click="handleNodeClick"
              >
                <template #default="{ node }">
                  <el-tooltip
                    v-if="node.label.length > 15"
                    class="item"
                    effect="dark"
                    :content="node.label"
                    placement="right"
                  >
                    <div style="width: 205px" class="ellipsis">
                      {{ node.label }}
                    </div>
                  </el-tooltip>
                  <span v-else> {{ node.label }}</span>
                </template>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="middle">
        <img
          style="cursor: pointer"
          src="@/assets/img/agreement/right-arrow.png"
        />
      </div>
      <div class="right">
        <div class="title">选中物料类别列表:</div>
        <div class="scrollbar">
          <el-scrollbar ref="scrollbarCategory3" style="height: 100%">
            <ul>
              <li
                v-for="(item, index) in mdmDataList"
                :key="index"
                class="scrollbar-li"
              >
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                  "
                >
                  <el-tooltip
                    v-if="item.categoryName.length > 15"
                    :content="item.categoryName"
                    placement="top"
                    effect="light"
                  >
                    <div
                      style="width: 100%; margin-right: 20px"
                      class="ellipsis"
                    >
                      {{ item.categoryName }}
                    </div>
                  </el-tooltip>
                  <div
                    v-else
                    style="width: 100%; margin-right: 20px"
                    class="ellipsis"
                  >
                    {{ item.categoryName }}
                  </div>
                  <div>
                    <eui-icon
                      icon="eicon-close"
                      font-size="12px"
                      @click.native.prevent="handleDeleteData"
                    ></eui-icon>
                    <!-- <img style="width: 12px; height: 12px" src="../../../../assets/img/agreement/close.png" @click="handleDeleteData(item)" /> -->
                  </div>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/product/index';
import Api from '@/modules/projectA/api/agreement/index';

export default {
  props: {
    category: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      //   defaultCheckedKeys: [
      //   677
      //   ],
      //   currentNodeKey:677,
      searchTreeShow: false,
      treeData: [],
      searchTreeData: [],
      mdmCategoryQuery: {
        mdmCategoryName: '',
      },
      mdmDataList: [],
      defaultProps: {
        label(a) {
          return `${a.mdmCategoryCode}-${a.categoryName}`;
        },
        isLeaf: 'isLeaf',
        disabled(a) {
          return a.categoryLevel == 1;
        },
      },
      searchTreeProps: {
        label(a) {
          return `${a.mdmCategoryCode}-${a.categoryName}`;
        },
        children: 'children',
        disabled(a) {
          return a.categoryLevel == 1;
        },
      },
    };
  },
  mounted() {
    this.mdmDataList = this.category;
  },
  methods: {
    // 对象数组去重
    uniqueMDMCategory(arr) {
      const res = new Map();
      return arr.filter(
        (arr) =>
          !res.has(arr.categoryId) &&
          res.set(arr.categoryId, 1) &&
          arr.isLeaf === 1
      );
    },
    mdmHandleSearch() {
      if (!this.mdmCategoryQuery.mdmCategoryName) {
        this.searchTreeShow = false;
      } else {
        const params = { categoryName: this.mdmCategoryQuery.mdmCategoryName };
        api.selectCategoryRouteList(params).then((res) => {
          this.searchTreeShow = true;
          this.searchTreeData = this.covertATree(res.data);
        });
      }
    },
    loadNode(node, resolve) {
      let tempParentId = 0;
      if (node.level != 0) {
        tempParentId = node.data.categoryId;
      }
      const params = {
        categoryId: tempParentId,
      };
      Api.addMdmType(params)
        .then((res) => {
          console.log(res, 'res');
          if (res && res.code === '200') {
            resolve(
              res.data.map((item) => {
                return {
                  ...item,
                  isLeaf: item.isLeaf === 1,
                };
              })
            );
            // this.$nextTick(() => {
            //   this.$refs.tree.setCurrentKey(this.mdmDataList && this.mdmDataList[0].categoryId);
            // });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    covertATree(arr) {
      const tempObj = [];

      // 将后台返回的数组拼成一个无重复数据的大数组
      arr.forEach((item) => {
        for (let i = 0; i < item.routeList.length; i++) {
          if (
            tempObj.findIndex((item1) => {
              return item1.categoryId === item.routeList[i].categoryId;
            }) == -1
          ) {
            tempObj.push(item.routeList[i]);
          }
        }
      });

      // 将拼好的数组转换成树

      const cloneData = JSON.parse(JSON.stringify(tempObj));
      return cloneData.filter((parent) => {
        const branchArr = cloneData.filter(
          (child) => parent.categoryId == child.parentId
        );
        branchArr.length > 0 ? (parent.children = branchArr) : '';
        return parent.parentId == -1;
      });
    },
    changeColor(val) {
      // 匹配关键字正则
      const replaceReg = new RegExp(this.mdmCategoryQuery.mdmCategoryName, 'g');
      // 高亮替换 v-html 值
      const replaceString = `<span style='color: red'>${this.mdmCategoryQuery.mdmCategoryName}</span>`;
      val = val.replace(replaceReg, replaceString);

      return val;
    },

    handleNodeClick(item) {
      if (this.$route.query.type === 'detail') {
        return;
      }
      console.log(item);
      if (item.isLeaf) {
        this.mdmDataList = [item];
        this.$emit('change', this.mdmDataList);
      }
    },
    handleDeleteData() {
      if (this.$route.query.type === 'detail') {
        return;
      }
      this.mdmDataList = [];
      this.$emit('change', this.mdmDataList);
    },
  },
};
</script>

<style lang="scss" scoped>
.container-purchase {
  position: relative;
  .model {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    background: #fff;
    opacity: 0.5;
    z-index: 99;
  }
  background: #f8f8f8;
  width: 100%;
  height: 424px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  .left {
    width: 470px;
    height: 360px;
    background-color: #ffffff;
    padding: 10px 10px 10px;
    .search {
      width: 100%;
      .scrollbar {
        height: 242px;
        overflow: hidden;
      }
    }
  }
  .right {
    width: 470px;
    height: 360px;
    background-color: #ffffff;
    padding: 10px 0px;
    .title {
      padding: 0px 10px;
    }
    .scrollbar {
      height: 316px;
      overflow: hidden;
      .scrollbar-li {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        padding: 0px 10px;
        &:hover {
          background: #f4f7ff;
        }
      }
      .scrollbar-active {
        background: #f4f7ff;
      }
    }
  }
  .middle {
    flex: 1;
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 35px;
      width: 18px;
    }
  }
  .tip {
    font-size: 14px;
    color: #999999;
  }
}
.agreement-label {
  .el-form-item__label:before {
    content: '* ';
    color: red;
  }
}
</style>
